"use strict";

if (document.querySelector('.animals-car__swiper')) {
  var swiper = [];
  document.querySelectorAll('.animals-car__swiper').forEach(function (item, index) {
    var speed = item.dataset.speed;
    swiper[index] = new Swiper(item, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: false,
      pagination: false,
      navigation: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      autoplay: {
        delay: speed ? speed : '5000'
      },
      breakpoints: {
        576: {
          slidesPerView: 2
        },
        768: {
          slidesPerView: 'auto'
        }
      },
      on: {
        slideChangeTransitionEnd: function slideChangeTransitionEnd() {
          this.autoplay.start();
        },
        slideResetTransitionEnd: function slideResetTransitionEnd() {
          this.autoplay.start();
        },
        resize: function resize() {
          this.autoplay.start();
        }
      }
    });
  });
}